import styled from '@emotion/styled'
import { css } from '@emotion/core'

export const FocusSpan = styled('span')`
  position: relative;
  pointer-events: none;
  ::after {
    width: 100%;
    height: 2px;
    background: currentColor;
    display: block;
    opacity: 0;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: all 200ms ease-out;
    visibility: hidden;
    @media only screen and (min-width: 768px) and (max-width: 1023px) {
      display: flex;
      font-size: 13px;
    }
  }
`

export const btnFocus = css`
  transition: background 250ms ease-in-out;

  :focus {
    outline: none;
    background: rgba(255, 255, 255, 0.15);
  }
`

export const underlineFocus = css`
  :focus {
    outline: none;

    ${FocusSpan}::after {
      opacity: 0.5;
      visibility: visible;
    }
  }

  :active ${FocusSpan}::after {
    opacity: 0;
    visibility: hidden;
  }
`

export const defaultFocus = css`
  :focus {
    outline: none;
    text-decoration: underline;
  }

  :active {
    text-decoration: none;
  }
`
